import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <div className="footer-content">
        <div className="footer-col">
          <div className="footer-logo">BOOK<span style={{color:'#F97316'}}>MY</span>GROUND</div>
          <p className="footer-about">We make sports simple and accessible by helping players, teams, and academies easily find and book sports grounds across Dubai.</p>
          <div className="footer-social">
            <a href="#" className="social-icon" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
            <a href="#" className="social-icon" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
            <a href="#" className="social-icon" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            <a href="#" className="social-icon" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
            <a href="#" className="social-icon" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
          </div>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><a href="#"><i className="fas fa-chevron-right"></i> About Us</a></li>
            <li><a href="#"><i className="fas fa-chevron-right"></i> How It Works</a></li>
            <li><a href="#"><i className="fas fa-chevron-right"></i> Popular Grounds</a></li>
            <li><a href="#"><i className="fas fa-chevron-right"></i> Become a Partner</a></li>
            <li><a href="#"><i className="fas fa-chevron-right"></i> FAQ</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact Us</h4>
          <div className="contact-info">
            <div className="contact-item"><i className="fas fa-map-marker-alt"></i><span>Al ittihad private school, Al safa. Jumeirah</span></div>
            <div className="contact-item"><i className="fas fa-phone"></i><span>0527132921</span></div>
            <div className="contact-item"><i className="fas fa-envelope"></i><span>support@bookmyground.today</span></div>
            <div className="contact-item"><i className="fas fa-clock"></i><span>Sun-Sat: 12AM-11PM</span></div>
          </div>
        </div>

        <div className="footer-col">
          <h4>Newsletter</h4>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize:'0.8rem', marginBottom:'8px' }}>Subscribe for updates & offers!</p>
          <div className="newsletter-form">
            <div className="newsletter-input">
              <input type="email" placeholder="Your email" />
              <button><i className="fas fa-paper-plane"></i> Subscribe</button>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="copyright">© 2025 BookMyGround. Made with <i className="fas fa-heart" style={{ color: '#F97316' }}></i> in Dubai</div>
        <div className="footer-bottom-links">
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
          <a href="#">Sitemap</a>
        </div>
        <div className="payment-methods">
          <i className="fab fa-cc-visa"></i>
          <i className="fab fa-cc-mastercard"></i>
          <i className="fab fa-cc-paypal"></i>
        </div>
      </div>
    </footer>
  );
};

export default Footer;